import { Controller } from "stimulus"

export default class extends Controller {
  static values = { baseUrl: String }

  toggle(e) {
    const inputTag = e.target
    const tagId = inputTag.dataset.id

    if (inputTag.checked) {
      this.createTagging(tagId)
    } else {
      this.deleteTagging(tagId)
    }
  }

  createTagging(tagId) {
    $.ajax({
      url: this.baseUrlValue,
      method: "POST",
      data: { tag_id: tagId },
    })
  }

  deleteTagging(tagId) {
    $.ajax({
      url: this.baseUrlValue + "/" + tagId,
      method: "DELETE",
    })
  }
}
